import React from 'react';
import _ from 'underscore';
import { cn } from '@/lib/utils';

// Renders the discount bands under the commitment month pills. Uses the same
// grid template as renderGridPillGroup in form.jsx (one equal column per
// month option) so each band spans exactly the months it applies to; px-1
// mirrors the pill track's p-1 inset to keep the columns flush.
class CommitmentDiscountHints extends React.Component {

  render() {
    const options = this.props.pricing_calculator.options.commitment_in_months
    const applied = this.props.pricing_calculator.discounts.commitment_in_months || null

    // Group consecutive options sharing a discount into one band.
    const bands = []
    _.each(options, (commitment, index) => {
      const last = bands[bands.length - 1]
      if (last && last.discount === commitment.discount_percentage) {
        last.span += 1
      } else {
        bands.push({ discount: commitment.discount_percentage, start: index + 1, span: 1 })
      }
    })

    return (
      <div
        className="mt-1 grid gap-1 px-1 max-md:hidden"
        style={{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }}
      >
        {bands.map((band) => {
          const active = band.discount == applied
          return (
            <span
              key={band.start}
              style={{ gridColumn: `${band.start} / span ${band.span}` }}
              className={cn(
                'flex h-6 items-center justify-center rounded-full text-xs font-bold',
                // Red to match the "X% Discount" label in the section heading
                // (DiscountLabel renders destructive) — ties the active band
                // to the applied discount rather than reading as a button.
                active ? 'bg-destructive text-destructive-foreground' : 'bg-muted text-muted-foreground/70'
              )}
            >
              {band.discount || 0}%
            </span>
          )
        })}
      </div>
    );
  }
}

export default CommitmentDiscountHints
